import { defineComponent as _defineComponent } from 'vue';
import { EnumActivityRiskProfile, useGetActivityQuery, useUpdateActivityMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetActivityQuery = useGetActivityQuery(computed(function () {
        return {
          id: route.params.id
        };
      })),
      result = _useGetActivityQuery.result;
    var item = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getActivity) || {};
    });
    var _useUpdateActivityMut = useUpdateActivityMutation(),
      updateActivity = _useUpdateActivityMut.mutate,
      onDone = _useUpdateActivityMut.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    return {
      __sfc: true,
      route: route,
      result: result,
      item: item,
      updateActivity: updateActivity,
      onDone: onDone,
      EnumActivityRiskProfile: EnumActivityRiskProfile
    };
  }
});